export interface IGif {
  id: string;
  searchQuery?: string;
  url?: string;
}

interface IGifMedia {
  dims: [number, number];
  size: number;
  url: string;
}

export enum SizeOfGif {
  Small = "nanogif",
  Medium = "tinygif",
  Big = "gif",
}

export type GifSize = `${SizeOfGif}`;

export interface ITenorResponse {
  results: IGifResponse[];
}

interface IGifResponse {
  id: string;
  media: IGifMedia;
}

export type GifType = "trending" | "search" | "gifs";

export type GifMenuPosition = "top" | "middle" | "bottom";
